import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ actions
import { initSelectFilter, setSelectFilter } from 'actions/filters';

class SelectorFilter extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {
            filtersId,
            filterId,
            filterType,
            immFilter,
            initialSelected,
            noFilterId,
            initSelectFilter,
            options,
            isTaggable
        } = this.props;

        const foundOption = options.find(option => option.value === initialSelected);
        const label = foundOption ? foundOption.label : '';

        !immFilter && initSelectFilter(
            filtersId,
            filterId,
            noFilterId != initialSelected,
            initialSelected,
            initialSelected,
            filterType,
            label,
            null,
            isTaggable
        );
    }

    handleSelectorChange = (event) => {
        const {
            filtersId,
            filterId,
            noFilterId,
            setSelectFilter,
            options
        } = this.props;
        const label = options.find(option => option.value == event.value).label;
        setSelectFilter(filtersId, filterId, noFilterId != event.value, event.value, label);
    }

    render() {
        const {
            filterId,
            immFilter,
            errorState,
            errorMessage,
            noResultsText,
            showLabel,
            disabled,
            openUp,
            openOnFocus,
            tooltipMsg,
            tooltipCustomClass,
            optionalElement,
            placeholder,
            options,
        } = this.props;
        if (immFilter) {
            const selected = immFilter.get('selected');
            return (
                <OKSelect
                    name={filterId}
                    onChange={this.handleSelectorChange}
                    options={options}
                    value={selected}
                    searchable={false}
                    errorState={errorState}
                    errorMessage={errorMessage}
                    noResultsText={noResultsText}
                    showLabel={showLabel}
                    disabled={disabled}
                    openUp={openUp}
                    openOnFocus={openOnFocus}
                    tooltipContent={tooltipMsg}
                    tooltipCustomClass={tooltipCustomClass}
                    optionalElement={optionalElement}
                    placeholder={placeholder}

                />
            );
        } else {
            return null
        }
    }
}

SelectorFilter.defaultProps = {
    filterType: 'selectorFilter',
    isTaggable: true,
}

SelectorFilter.propTypes = {
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    errorState: PropTypes.bool,
    filterId: PropTypes.string.isRequired,
    filtersId: PropTypes.string.isRequired,
    filterType: PropTypes.string.isRequired,
    immFilter: PropTypes.object,
    isTaggable: PropTypes.bool,
    initialSelected: PropTypes.string.isRequired,
    initSelectFilter: PropTypes.func.isRequired,
    noFilterId: PropTypes.string.isRequired,
    noResultsText: PropTypes.string,
    openUp: PropTypes.bool,
    openOnFocus: PropTypes.bool,
    optionalElement: PropTypes.object,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    selected: PropTypes.string,
    setSelectFilter: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    tooltipCustomClass: PropTypes.string,
    tooltipMsg: PropTypes.any,
};

export default connect(
    null,
    {
        initSelectFilter,
        setSelectFilter
    }
)(SelectorFilter);